import { ActionContext } from 'vuex';

import { DEFAULT_PAGINATION_PAGE } from '@/common/constants/page';
import { TApiResponse } from '@/common/types/response';
import { mapSortParams } from '@/common/utils/sort';
import { getLocalState } from '@/common/utils/store';

import { prepareIndicatorPage } from '../../api/indicatorLoadMonitoring';
import { INDICATOR_LOAD_MONITORING_ACTIONS_NAME, INDICATOR_LOAD_MONITORING_MUTATIONS_NAME } from './name';
import { TIndicatorMonitoringState, TIndicatorPage, TIndicatorPageDto } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getMonitoringPage(
  context: ActionContext<TIndicatorMonitoringState, unknown>,
  payload: { params?: Record<string, unknown>; abortController?: AbortController },
): Promise<{ data: TIndicatorPage }> {
  const res = (await request(
    context,
    {
      url: links.importAnalytics.indicatorLoadMonitoring.getIndicators,
      name: INDICATOR_LOAD_MONITORING_ACTIONS_NAME.getMonitoringPage,
      abortController: payload?.abortController,
    },
    mapSortParams(payload?.params ?? {}),
  )) as TApiResponse<TIndicatorPageDto>;

  context.commit(getLocalState(INDICATOR_LOAD_MONITORING_MUTATIONS_NAME.setLoadError), !res.success);

  return { data: res.success ? prepareIndicatorPage(res.data) : { ...DEFAULT_PAGINATION_PAGE } };
}

export async function getUpdateStatuses(context: ActionContext<TIndicatorMonitoringState, unknown>) {
  await request(
    context,
    {
      url: links.importAnalytics.indicatorLoadMonitoring.getUpdateStatuses,
      name: INDICATOR_LOAD_MONITORING_ACTIONS_NAME.getUpdateStatuses,
      mutate: getLocalState(INDICATOR_LOAD_MONITORING_MUTATIONS_NAME.setUpdateStatuses),
    },
    {},
  );
}

export async function getSources(context: ActionContext<TIndicatorMonitoringState, unknown>) {
  await request(
    context,
    {
      url: links.importAnalytics.indicatorLoadMonitoring.getSources,
      name: INDICATOR_LOAD_MONITORING_ACTIONS_NAME.getUpdateStatuses,
      mutate: getLocalState(INDICATOR_LOAD_MONITORING_MUTATIONS_NAME.setSources),
    },
    {},
  );
}
